import React from 'react';
import {connect} from 'react-redux';
import cs from 'classnames';
import {push as changeURL} from 'react-router-redux';
import isEmpty from 'lodash/isEmpty';
import trim from 'lodash/trim';
import includes from 'lodash/includes';
import format from 'date-fns/format';

import mapDispatch from '~/misc/mapDispatch';
import store from '~/store';
import {modalChange} from '~/modules/modal/actions';
import * as modes from '~/modules/modal/modes';
import AccountHeader from '../MyAccount/share/AccountHeader';
import ResetPassword from '../MyAccount/share/ResetPassword';
import Input from '../MyAccount/share/Input';
import Button from '~/components/common/Button';
import Spinner from '~/components/common/Spinner';
import {getUserAccountInfo, saveUserPageContactInfo, hideAsyncErrorMessage} from '~/modules/userAccountPage/actions';
import {hideChangePasswordAsyncErrorMessage} from '~/modules/user/actions';
import {hideErrorMsg} from '~/misc/hideErrorMsg';
import {regEmail, regPhone, regPassWord, regDot, regMc} from '~/misc/reg';
import {errorInfoConfig} from '~/misc/error-info';
import {changePassword} from '~/modules/user/actions';
import {formatPhone, formatNumberOnly} from '~/misc/formatPhone';
import {track} from '~/misc/metrics';
import VerifyAccount from '~/components/pages/MyAccount/share/VerifyAccount';
import {getFetchedJSON} from '~/misc/fetch';

import css from './index.css';
import sharedCSS from '~/components/shared.css';

class UserAccount extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      initFormData: {},
      formData: {},
      formControl: {},
      initControl: {},
    };
    this.getPageInfo = this.getPageInfo.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.cancelChange = this.cancelChange.bind(this);
    this.changePassword = this.changePassword.bind(this);
    this.saveChange = this.saveChange.bind(this);
    this.handleDotMcBlur = this.handleDotMcBlur.bind(this);
  }

  componentWillMount() {
    track('my account', {'My account - homepage': 1});
    if (!this.props.user.token
      || (this.props.account.userInfo.data && this.props.account.userInfo.data.memberPlan === 'Free')
    ) {
      this.props.goToRoot();
    }
    if (this.props.account.userInfo.data) {
      this.getPageInfo();
    }
    this.initFormValue();
  }

  componentWillReceiveProps(nextProps) {
    if (!this.props.account.userInfo.data && nextProps.account.userInfo.data) {
      this.getPageInfo();
    }

    if (this.props.user.id && (this.props.user.id !== nextProps.user.id)
      || (this.props.account.userInfo.data && this.props.account.userInfo.data.memberPlan === 'Free')
      || (nextProps.account.userInfo.data && nextProps.account.userInfo.data.memberPlan === 'Free')
    ) {
      this.props.goToRoot();
    }

    if (
      ((JSON.stringify(this.props.user) !== JSON.stringify(nextProps.user))
      && nextProps.user.isLoggedIn
      && this.props.user.loading
    )) {
      this.initFormValue(nextProps.user);
    }
    this.judgeRoute();
  }

  render() {
    return (
      <div className={cs(sharedCSS.widewrap, 'qa-content')}>
        <div className={cs(sharedCSS.wideStretchable, css.wrap)}>
          {this.renderContent()}
        </div>
      </div>
    );
  }

  renderContent() {
    const accountInfo = this.props.account.userInfo.data;
    const userAccountInfo = this.props.userAccountPage.userAccountInfo;
    const changePasswordErrorMessage = this.props.user.changePasswordErrorMessage
      ? this.props.user.changePasswordErrorMessage
      : null;

    if (userAccountInfo.error) {
      return (
        <div className={cs(css.removeBg, css.center)} onClick={this.getPageInfo}>
          {userAccountInfo.error}
        </div>
      );
    }
    if (!isEmpty(userAccountInfo.data) && (userAccountInfo.data.memberPlan !== 'Free')) {
      const formData = this.state.formData;
      const formControl = this.state.formControl;
      return (
        <div className={cs(css.content)}>
          <AccountHeader
            tit='Account Information'
            titleInfo={
              'Please complete and edit your account information.'
              + ' The more information you provide the better your chance of getting business.'
            }
          />
          <VerifyAccount />
          <div className={css.infoWrap}>
            <ul>
              <li>
                Membership plan:{' '}
                <span className={css.colorBlue}>{accountInfo.memberPlan ? accountInfo.memberPlan : ''}</span>
              </li>
              <li>
                Next billing date:{' '}
                <span className={css.colorBlue}>
                  {accountInfo.nextBillDate ? format(accountInfo.nextBillDate, 'DD/MM/YY') : ''}
                </span>
              </li>
              <li>
                Member ID:{' '}
                <span className={css.colorBlue}>{accountInfo.memberId ? accountInfo.memberId : ''}</span>
              </li>
            </ul>
          </div>
          <div className={css.tit}>1、 Contact Information
            {this.props.dots.mainSwitch.data.email_switch.switch
              && !this.props.user.infoIsComplete
              && (<span className={css.updateInfo}>
                Update your Contact Info to validate your account.
              </span>)
            }
          </div>
          <form className={css.formWrap}>
            <Input
              mods={['floatLef', 'half']}
              title={'First Name'}
              label={'firstName'}
              type='text'
              defaultValue={formData.firstName}
              fnChange={this.handleChange}
              fnBlur={this.handleBlur}
              error={formControl.firstName ? formControl.firstName.error : ''}
            />
            <Input
              mods={['floatRigt', 'half']}
              title={'Last Name'}
              label={'lastName'}
              type='text'
              defaultValue={formData.lastName}
              fnBlur={this.handleBlur}
              fnChange={this.handleChange}
              error={formControl.lastName ? formControl.lastName.error : ''}
            />
            <Input
              mods={['floatLef', 'half']}
              title={'Phone'}
              label={'phone'}
              type='phone'
              defaultValue={formatPhone(formData.phone)}
              fnBlur={this.handleBlur}
              fnChange={this.handleChange}
              error={formControl.phone ? formControl.phone.error : ''}
            />
            <Input
              mods={['floatRigt', 'half']}
              title={'Company'}
              label={'company'}
              type='text'
              defaultValue={formData.company}
              fnBlur={this.handleBlur}
              fnChange={this.handleChange}
              error={formControl.company ? formControl.company.error : ''}
            />
            <Input
              mods={['floatLef', 'half']}
              title={'DOT'}
              label={'dot'}
              type='dot'
              defaultValue={formData.dot}
              fnChange={this.handleBlur}
              fnBlur={this.handleDotMcBlur}
              error={formControl.dot ? formControl.dot.error : ''}
            />
            <Input
              mods={['floatRigt', 'half']}
              title={'MC'}
              type='mc'
              label={'mc'}
              defaultValue={formData.mc}
              fnChange={this.handleBlur}
              fnBlur={this.handleDotMcBlur}
              error={formControl.mc ? formControl.mc.error : ''}
            />
            <Input
              mods={['floatRigt', 'strench']}
              title={'Identity'}
              label={'identity'}
              placeholder='Fleet manager / Ind. owner operator …'
              type='text'
              defaultValue={formData.identity}
              fnBlur={this.handleBlur}
              fnChange={this.handleChange}
              error={formControl.identity ? formControl.identity.error : ''}
            />
          </form>
          <div className={css.footerWrap}>
            {this.props.userAccountPage.saveContactInfo.error && (
              <div className={css.tips}>
                {hideErrorMsg('saveContactInfo', this.props.userAccountPage.saveContactInfo, hideAsyncErrorMessage)}
              </div>
            )}
            <div className={css.btnWrap}>
              <Button className={cs(css.wide)} onClick={this.cancelChange} mods={['large']} >Cancel</Button>
              <Button
                className={cs(css.marginLef, css.wide)}
                onClick={this.saveChange}
                mods={['large', 'action']}
                disable={Boolean(this.props.userAccountPage.saveContactInfo.disable)}
              >Save</Button>
            </div>
          </div>

          <div className={css.tit}>2、 Reset Password</div>
          <ResetPassword
            handleChange={this.handleChange}
            handleBlur={this.handleBlur}
            errorControl={this.state.formControl}
          />
          <div className={css.footerWrap}>
            <div className={css.btnWrap}>
              {changePasswordErrorMessage && (
                <div className={css.tips}>
                  {hideErrorMsg(
                    'CHANGE_PASSWORD_ASYNG_ERROR_HIDE',
                    changePasswordErrorMessage,
                    hideChangePasswordAsyncErrorMessage
                  )}
                </div>
              )}
              <Button
                className={cs(css.marginLef, css.wide)}
                onClick={this.changePassword}
                mods={['large', 'action']}
              >Save</Button>
            </div>
          </div>
        </div>
      );
    }
    return (
      <div className={css.spinnerLine}>
        <div className={css.spinner}>
          <Spinner scalable={true}/>
        </div>
      </div>
    );
  }

  judgeRoute() {
    if (!isEmpty(this.props.account.userInfo.data) && includes(this.props.account.userInfo.data.userRole, 'admin')) {
      this.props.goToAdminAccount();
    }
  }

  getPageInfo() {
    store.dispatch((dispatch, getState) => getUserAccountInfo(dispatch, getState));
  }

  initFormValue(param) {
    const emailSwitch = this.props.dots.mainSwitch.data.email_switch.switch;
    const user = param ? param : this.props.user;
    const contactData = {
      firstName: user.firstName || '',
      lastName: user.lastName || '',
      phone: formatPhone(user.phone) || '',
      company: user.company || '',
      dot: user.dot || '',
      mc: user.mc || '',
      identity: user.identity || '',
    };
    const initDotMcData = (type, data, emailSwitch) => {
      switch (type) {
        case 'dot':
          if (emailSwitch) {
            if (!data.dot_verified && data.dot) {
              return {
                error: errorInfoConfig.dot.wrong,
                onClick: false,
              };
            }
            if (!data.dot_verified && !data.dot && !data.mc) {
              return {
                error: errorInfoConfig.dot.empty,
                onClick: false,
              };
            }
          } else {
            if (!data.dot && !data.mc) {
              return {
                error: errorInfoConfig.dot.wrong,
                onClick: false,
              };
            }
            return '';
          }
          return '';
        case 'mc':
          if (emailSwitch && !data.mc_verified && !data.dot && data.mc) {
            return {
              error: errorInfoConfig.mc.wrong,
              onClick: false,
            };
          }
          return '';
        default:
          return null;
      }
    };
    const initFormControl = {
      firstName: user.firstName ? '' : {error: errorInfoConfig.text.empty, onClick: false},
      lastName: user.lastName ? '' : {error: errorInfoConfig.text.empty, onClick: false},
      phone: !user.phone
            ? {
              error: errorInfoConfig.phone.empty,
              onClick: false,
            }
            : !regPhone.test(formatPhone(user.phone))
            // : !user.verified_phone
            ? {
              error: errorInfoConfig.phone.wrong,
              onClick: false,
            }
            : '',
      company: user.company ? '' : {error: errorInfoConfig.text.empty, onClick: false},
      dot: initDotMcData('dot', user, emailSwitch),
      mc: initDotMcData('mc', user, emailSwitch),
      // dot: !user.dot
      //       ? {
      //         error: errorInfoConfig.dot.empty,
      //         onClick: false,
      //       }
      //       : !user.dot_verified
      //       ? {
      //         error: errorInfoConfig.dot.wrong,
      //         onClick: false,
      //       }
      //       : '',
      // mc: '',
      identity: user.identity ? '' : {error: errorInfoConfig.text.empty, onClick: false},
    };
    this.setState({
      initFormData: contactData,
      formData: contactData,
      formControl: this.props.dots.mainSwitch.data.email_switch.switch ? initFormControl : {},
      initControl: this.props.dots.mainSwitch.data.email_switch.switch ? initFormControl : {},
    });
  }

  processDataAndSetState(typeName, errorTips, inputVal, clickType) {
    this.setState({
      formData: {
        ...this.state.formData,
        [typeName]: inputVal,
      },
      formControl: {
        ...this.state.formControl,
        [typeName]: {
          error: errorTips,
          onClick: clickType,
        },
      },
    });
  }

  regData(inputVal, emptyErrorTips, wrongErrorTips, regMethodType, typeName) {
    if (!inputVal) {
      return this.processDataAndSetState(typeName, emptyErrorTips, inputVal, false);
    }
    if (regMethodType && !regMethodType.test(inputVal)) {
      return this.processDataAndSetState(typeName, wrongErrorTips, inputVal, false);
    }
    return this.processDataAndSetState(typeName, '', inputVal, true);
  }

  filterEmptyInputVal(formData) {
    let emptyValue = {};
    Object.keys(formData).forEach((key) => {
      if (!formData[key]) {
        if (key === 'old_password') {
          emptyValue[key] = {
            error: errorInfoConfig.password.empty,
            onClick: false,
          };
          return;
        }
        if (key === 'new_password') {
          emptyValue[key] = {
            error: errorInfoConfig.password.empty,
            onClick: false,
          };
          return;
        }
        if (key === 'confirm_password') {
          emptyValue[key] = {
            error: errorInfoConfig.password.empty,
            onClick: false,
          };
          return;
        }
        emptyValue[key] = {
          error: errorInfoConfig.text.empty,
          onClick: false,
        };
        return;
      }
    });
    return emptyValue;
  }

  canClickOrNot(formControl) {
    let emptyValue = [];
    Object.keys(formControl).forEach((key, index) => {
      if (key !== 'mc') {
        if (formControl[key].onClick) {
          emptyValue[index] = true;
          return;
        } else if (formControl[key].onClick === false) {
          emptyValue[index] = false;
          return;
        }
      }
      return;
    });

    if (!includes(emptyValue.toString(), 'false')) {
      return true;
    }

    return false;
  }

  handleBlur(e) {
    const name = e.target.name;
    const type = e.target.getAttribute('data-inputType');
    const inputVal = trim(e.target.value);

    switch (type) {
      case 'password': {
        return this.regData(
          inputVal,
          errorInfoConfig.password.empty,
          errorInfoConfig.password.wrong,
          regPassWord,
          name
        );
      }
      case 'text': {
        return this.regData(
          inputVal,
          errorInfoConfig.text.empty,
          errorInfoConfig.text.wrong,
          false,
          name
        );
      }
      case 'email': {
        return this.regData(
          inputVal,
          errorInfoConfig.email.empty,
          errorInfoConfig.email.wrong,
          regEmail,
          name
        );
      }
      case 'phone': {
        return this.regData(
          formatPhone(inputVal),
          errorInfoConfig.phone.empty,
          errorInfoConfig.phone.wrong,
          regPhone,
          name
        );
      }
      case 'dot': {
        return this.regData(
          formatNumberOnly(inputVal, 7),
          '',
          errorInfoConfig.dot.wrong,
          regDot,
          name);
      }
      case 'mc': {
        return this.regData(
          formatNumberOnly(inputVal, 6),
          '',
          errorInfoConfig.mc.wrong,
          regMc,
          name);
      }
      case 'notNeed': {
        return this.regData(
          inputVal,
          '',
          '',
          false,
          name
        );
      }
    }
    return null;
  }

  handleChange(e) {
    return this.setState({
      formData: {
        ...this.state.formData,
        [e.target.name]: e.target.value,
      },
    });
  }

  cancelChange() {
    return this.setState({
      formData: this.state.initFormData,
      formControl: this.state.initControl,
    });
  }

  changePassword() {
    track('my account', {'Account profile – change password': 1});
    const formData = this.state.formData;
    const passwordFromData = {
      old_password: formData.old_password,
      new_password: formData.new_password,
      confirm_password: formData.confirm_password,
    };

    let emptyValue = this.filterEmptyInputVal(passwordFromData);

    if (isEmpty(emptyValue) && this.canClickOrNot(emptyValue)) {
      if (passwordFromData.new_password !== passwordFromData.confirm_password) {
        return this.setState({
          formControl: Object.assign(emptyValue,
            {
              confirm_password: {
                error: errorInfoConfig.password.confirm,
                onClick: false,
              },
            }),
        });
      }
      return store.dispatch((dispatch, getState) => changePassword(dispatch, getState, passwordFromData));
    }
    const controlData = Object.assign(this.state.formControl, emptyValue);
    return this.setState({
      formControl: controlData,
    });
  }

  handleDotMcBlur(e) {
    const name = e.target.name;
    const type = e.target.getAttribute('data-inputType');
    const inputVal = trim(e.target.value);

    switch (type) {
      case 'dot': {
        if (!regDot.test(inputVal)) {
          return this.regData(
            formatNumberOnly(inputVal, 7),
            '',
            errorInfoConfig.dot.wrong,
            regDot,
            name);
        }

        return window.fetch(`https://api.truckerpath.com/services/saferwatch/dot/${inputVal}`, {
          method: 'GET',
        })
          .then(getFetchedJSON)
          .then(res => {
            const data = {
              companyDot: inputVal,
              companyMc: res['CarrierService.CarrierLookup'].CarrierDetails.docketNumber
                ? res['CarrierService.CarrierLookup'].CarrierDetails.docketNumber.slice(2)
                : '',
              companyName: res.identity.legalName,
            };
            this.regData(
              data.companyDot,
              '',
              '',
              false,
              'dot'
            );
            this.regData(
              data.companyMc,
              '',
              '',
              false,
              'mc'
            );
            this.regData(
              data.companyName,
              errorInfoConfig.text.empty,
              errorInfoConfig.text.wrong,
              false,
              'company'
            );
          })
          .catch(() => {
            this.processDataAndSetState(name, errorInfoConfig.dot.wrong, inputVal, true);
          });
      }
      case 'mc': {
        if (!regMc.test(inputVal)) {
          return this.regData(
            formatNumberOnly(inputVal, 6),
            '',
            errorInfoConfig.mc.wrong,
            regMc,
            'mc');
        }

        return window.fetch(`https://api.truckerpath.com/services/saferwatch/mc/${inputVal}`, {
          method: 'GET',
        })
          .then(getFetchedJSON)
          .then(res => {
            const data = {
              companyDot: res['CarrierService.CarrierLookup'].CarrierDetails.dotNumber['#text'],
              companyMc: inputVal,
              companyName: res.identity.legalName,
            };
            this.regData(
              data.companyDot,
              '',
              '',
              false,
              'dot'
            );
            this.regData(
              data.companyMc,
              '',
              '',
              false,
              'mc'
            );
            this.regData(
              data.companyName,
              errorInfoConfig.text.empty,
              errorInfoConfig.text.wrong,
              false,
              'company'
            );
          })
          .catch(() => {
            this.processDataAndSetState(name, errorInfoConfig.mc.wrong, inputVal, true);
          });
      }
    }
    return null;
  }

  saveChange() {
    if (this.props.userAccountPage.saveContactInfo.disable) {
      return false;
    }

    const data = {
      firstName: this.state.formData.firstName || '',
      lastName: this.state.formData.lastName || '',
      phone: this.state.formData.phone || '',
      company: this.state.formData.company || '',
      dot: this.state.formData.dot || '',
      identity: this.state.formData.identity || '',
    };

    let emptyValue = {};

    Object.keys(data).forEach((key) => {
      if (!data[key]) {
        if (key === 'email') {
          emptyValue[key] = {
            error: errorInfoConfig.email.empty,
            onClick: false,
          };
          return;
        }
        if (key === 'dot') {
          if (!this.state.formData.mc) {
            emptyValue[key] = {
              error: errorInfoConfig.dot.empty,
              onClick: false,
            };
          }
          return;
        }
        if (key === 'phone') {
          emptyValue[key] = {
            error: errorInfoConfig.phone.empty,
            onClick: false,
          };
          return;
        }
        emptyValue[key] = {
          error: errorInfoConfig.text.empty,
          onClick: false,
        };
        return;
      }
    });
    emptyValue = Object.assign({}, this.state.formControl, emptyValue);
    let canSave = true;
    Object.keys(emptyValue).forEach((key) => {
      if (emptyValue[key] && emptyValue[key].error) {
        canSave = false;
      }
    });
    if (canSave) {
      const subObj = this.state.formData;
      if (subObj.phone) {subObj.phone = formatNumberOnly(subObj.phone);}

      return store.dispatch((dispatch, getState) => saveUserPageContactInfo(dispatch, getState, this.state.formData));
    }

    const controlData = Object.assign(this.state.formControl, emptyValue);
    return this.setState({
      formControl: controlData,
    });
  }
}

export default connect(
  ({user, userAccountPage, account, dots}) => ({user, userAccountPage, account, dots}
), mapDispatch({
  login: () => modalChange(modes.LOGIN, 'user-account'),
  signup: () => modalChange(modes.SIGNUP, 'user-account'),
  goToRoot: () => changeURL('/'),
  goToAdminAccount: () => changeURL('/my-account'),
}))(UserAccount);



// WEBPACK FOOTER //
// ./src/components/pages/UserAccount/index.js